import "./button.scss";
import React from "react";

interface IButton {
    type: "primary" | "secondary" | "primary-light" | "action-primary" | "action-secondary" | "filter";
    children: React.ReactNode;
    action: () => void
    responsive: boolean
    className?: string
}

const Button = ({type, children, action, responsive, className}: IButton) => {
    return (
        <button onClick={() => action()}
                className={responsive ? type + " responsive " + className : type + " " + className}>{children}</button>
    );
}

export default Button;